export default __webpack_public_path__ + "static/media/staffing_table_info.d5835ff8.svg";